import type { CMSAssetRecentActivity } from '../types';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { CMS_API_ROOT_URL, CMS_RECENT_ACTIVITY_KEY } from '../constants';

export type GetRecentActivityResponse = {
  data: CMSAssetRecentActivity[];
  totalPages: number;
  rowsPerPage: number;
  totalCount: number;
};

const getRecentActivity = (
  assetId: string,
  currentPage: number,
  rowsPerPage: number,
): Promise<GetRecentActivityResponse> => {
  const url = `${CMS_API_ROOT_URL}/list/${assetId}?current_page=${currentPage}&rows_per_page=${rowsPerPage}`;
  return FetchPromise.get(url);
};

export const useGetRecentActivity = (assetId: string, currentPage: number, rowsPerPage: number) =>
  useQuery<GetRecentActivityResponse, JQuery.jqXHR>([CMS_RECENT_ACTIVITY_KEY, assetId, currentPage, rowsPerPage], () =>
    getRecentActivity(assetId, currentPage, rowsPerPage),
  );
